/// <amd-module name="SearchUI/WikiSearchResultItem" />
export * from "SearchUI/Components/WikiSearchResultComponent/index";